import { Entity } from './entity.js';

export class ClientEntity extends Entity
{
    clientId!: string;
    keycloakId!: string;
}